import axios from "axios";

const instance = axios.create({
  baseURL: "http://localhost:5001/challenge-31759/us-central1/api", //The API (cloud function) URL
  //'https://us-central1-challenge-31759.cloudfunctions.net/api',
});

export default instance;
